<template>
  <of-dialog :title="formTitle" @onCancel="cancel" :width="width">
    <div slot="content">
      <el-form label-width="120px" :model="dataForm">
        <el-form-item
          label="基础信息"
          style="background-color: #f8f8f9"
          label-width="80px"
        ></el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="求助人姓名："
              >{{ dataForm.Name }}
            </el-form-item></el-col
          >
          <el-col :span="12">
            <el-form-item label="性别："
              >{{ showSex(dataForm.Sex) }}
            </el-form-item></el-col
          >
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="户籍所在地："
              >{{ dataForm.NationPlace }}
            </el-form-item></el-col
          >
          <el-col :span="12">
            <el-form-item label="年龄："
              >{{ dataForm.Age }}
            </el-form-item></el-col
          >
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="身份证号："
              >{{ dataForm.IdentityCard }}
            </el-form-item></el-col
          >
          <el-col :span="12">
            <el-form-item label="手机号："
              >{{ dataForm.Phone }}
            </el-form-item></el-col
          >
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="确诊病型："
              >{{ dataForm.Diagnosis }}
            </el-form-item></el-col
          >
          <el-col :span="12">
            <el-form-item label="家庭住址："
              >{{ dataForm.Address }}
            </el-form-item></el-col
          >
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="申请救助事由："
              >{{ dataForm.Describe }}
            </el-form-item></el-col
          >
        </el-row>
        <!-- <el-row>
          <el-col :span="24">
            <el-form-item label="附件：">
              <of-upload
                class="upload-demo"
                list-type="fileList"
                @onPreview="onFilePreview"
                :fileList="fileList"
                :class="{ hideFile: true }"
              >
              </of-upload> </el-form-item
          ></el-col>
        </el-row> -->
        <el-form-item
          label="家人联系方式"
          style="background-color: #f8f8f9"
          label-width="110px"
        ></el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="联系人姓名："
              >{{ dataForm.ContactName }}
            </el-form-item></el-col
          >
          <el-col :span="12">
            <el-form-item label="与申请人关系："
              >{{ dataForm.RelationShip }}
            </el-form-item></el-col
          >
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="联系人电话："
              >{{ dataForm.ContactPhone }}
            </el-form-item></el-col
          >
          <el-col :span="12">
            <el-form-item label="身份证号："
              >{{ dataForm.ContactIdCard }}
            </el-form-item></el-col
          >
        </el-row>
        <el-form-item
          label="银行账户"
          style="background-color: #f8f8f9"
          label-width="80px"
        ></el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="姓名："
              >{{ dataForm.BankUserName }}
            </el-form-item></el-col
          >
          <el-col :span="12">
            <el-form-item label="银行："
              >{{ dataForm.Bank }}
            </el-form-item></el-col
          >
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="银行卡号："
              >{{ dataForm.BankCardNo }}
            </el-form-item></el-col
          >
        </el-row>
        <el-form-item
          label="相关文件"
          style="background-color: #f8f8f9"
          label-width="80px"
        ></el-form-item>
        <el-row>
          <el-col :span="12">
            <div class="label-title">
              家庭成员户口簿
            </div>
            <el-image
              v-for="item in arrFileThree"
              :key="item.id"
              style="width: 100px; height: 100px; padding: 5px;"
              :src="item"
              :preview-src-list="[item]"
            >
            </el-image>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <div class="label-title">
              疾病诊断证明
            </div>
            <el-image
              v-for="item in arrFileSeven"
              :key="item.id"
              style="width: 100px; height: 100px; padding: 5px;"
              :src="item"
              :preview-src-list="[item]"
            >
            </el-image>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <div class="label-title">
              当地村（居）委会出具的家庭困难证明
            </div>
            <el-image
              v-for="item in arrFileEight"
              :key="item.id"
              style="width: 100px; height: 100px; padding: 5px;"
              :src="item"
              :preview-src-list="[item]"
            >
            </el-image>
          </el-col>
        </el-row>

        <el-form-item
          label="快递信息"
          style="background-color: #f8f8f9"
          label-width="80px"
          v-if="dataForm.ExpressCompany || dataForm.ExpressNo"
        ></el-form-item>
        <el-row v-if="dataForm.ExpressCompany || dataForm.ExpressNo">
          <el-col :span="12">
            <el-form-item label="快递公司："
              >{{ dataForm.ExpressCompany }}
            </el-form-item></el-col
          >
          <el-col :span="12">
            <el-form-item label="快递单号："
              >{{ dataForm.ExpressNo }}
            </el-form-item></el-col
          >
        </el-row>
      </el-form>
    </div>
  </of-dialog>
</template>
<script>
import OfDialog from "@/components/controls/of_dialog/of_dialog";
import OfUpload from "@/components/controls/of_upload/of_upload";
import { saveAs } from "file-saver";
import api from "@/modules/zjrc/api";

export default {
  name: "edit",
  props: {
    id: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      formTitle: "查看详情",
      width: "55%",
      dataForm: {},
      fileList: [], //附件数组
      arrFileThree: [],
      arrFileSeven: [],
      arrFileEight: [],
    };
  },
  components: {
    OfDialog,
    OfUpload,
  },
  mounted() {
    let that = this;
    that.loadData();
  },
  computed: {
    showSex() {
      return (data) => {
        return data == 0 ? "女" : "男";
      };
    },
  },
  methods: {
    //初始化数据
    loadData() {
      let that = this;
      let params = { Id: that.id };
      api.QueryBigSickApplyById(params).then((res) => {
        if (res.data.Code == 0) {
          that.dataForm = res.data.Data;
          // that.getlistfile();
          that.arrFileThree = JSON.parse(that.dataForm.FileThree);
          that.arrFileSeven = JSON.parse(that.dataForm.FileSeven);
          that.arrFileEight = JSON.parse(that.dataForm.FileEight);
        }
      });
    },
    //取消
    cancel() {
      this.$emit("formCallBack", null);
    },
    // //加载文件
    // getlistfile() {
    //   let that = this;
    //   if (that.dataForm.Files === undefined || that.dataForm.Files === null) {
    //     return;
    //   }
    //   let params = { Id: that.dataForm.Files };
    //   api.QueryBigSickApplyFileByIds(params).then((res) => {
    //     if (res.data.Code == 0) {
    //       let fileList = res.data.Data;
    //       fileList.forEach((item) => {
    //         that.fileList.push({url:item.Url,name:item.FileName});
    //       });
    //     }
    //   });
    // },
    //下载附件
    onFilePreview(file) {
      saveAs(file.url, file.name);
    },
  },
};
</script>
<style scoped>
.of-dialog >>> .el-button--primary {
  display: none;
}

.of-dialog >>> .el-button--default {
  display: none;
}
.el-form >>> .el-form-item__label {
  font-weight: 500;
}

.label-title {
  padding: 10px 0;
}
</style>

<style>
.hideFile .el-upload--fileList {
  display: none !important;
}
</style>
